export const DelayedJob = {

  list: function() {
    var table = jQuery('table#administration-delayed_jobs')
    table.DataTable({
      data: JSON.parse(jQuery('#delayed_job-table-data').html()),
      pageLength: 25,
      retrieve: true,
      lengthChange: false,
      language: {
        searchPlaceholder: I18n.t('search')
      },
      drawCallback: function() {
        var handlerRows = $(table).find('tbody tr>td:nth-child(3)');
        handlerRows.wrapInner("<span class='handler-content'></span>");
        handlerRows = handlerRows.find('span');
        handlerRows.addClass('close-handler');
        handlerRows.off('click').on('click', function() {
          if ($(this).hasClass('close-handler')) {
            $(this).removeClass('close-handler').addClass('open-handler');
          } else {
            $(this).removeClass('open-handler').addClass('close-handler');
          }
        })
      },
      footerCallback: function () {
        DataTablesHelper.togglePagination(this);
      }
    });
  }
}